import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { useDrillDownDialog } from "../DrillDownProvider";
import { DrillDownConfig, WidgetExplanationContent } from "../types";
import { WidgetExplanation } from "./WidgetExplanation";
import { whiteCardSx } from "./widgetStyles";

type WidgetCardProps = {
    title?: string;
    explanation: WidgetExplanationContent;
    headerControls?: React.ReactNode;
    bodyHeight?: number;
    // "center" (defeito) para gráficos/KPIs; "top" para conteúdo tabular — num cartão esticado
    // pela grelha, uma tabela centrada cria faixas brancas acima/abaixo.
    bodyAlign?: "top" | "center";
    isLoading?: boolean;
    isError?: boolean;
    drillDown?: DrillDownConfig;
    children: React.ReactNode;
};

export const WidgetCard = ({ title, explanation, headerControls, bodyHeight, bodyAlign = "center", isLoading, isError, drillDown, children }: WidgetCardProps) => {
    const drillDownDialog = useDrillDownDialog();
    const isClickable = Boolean(drillDown && drillDownDialog && !isLoading && !isError);

    return (
        <Paper
            elevation={0}
            onClick={isClickable ? () => drillDownDialog!.openDrillDown(drillDown!) : undefined}
            sx={{
                ...whiteCardSx,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                ...(isClickable ? { cursor: "pointer", "&:hover": { boxShadow: 4 } } : {}),
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={2}>
                <Box display="flex" alignItems="center" gap={1}>
                    {title && (
                        <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                            {title}
                        </Typography>
                    )}
                    <WidgetExplanation title={title || ""} explanation={explanation} />
                </Box>
                {headerControls && (
                    <Box display="flex" gap={2} onClick={(event) => event.stopPropagation()}>
                        {headerControls}
                    </Box>
                )}
            </Box>
            <Box flexGrow={1} width="100%" display="flex" flexDirection="column" justifyContent={bodyAlign === "top" ? "flex-start" : "center"}>
                {isLoading && <Skeleton variant="rounded" height={bodyHeight || 80} />}
                {!isLoading && isError && (
                    <Box height={bodyHeight} display="flex" alignItems="center" justifyContent="center">
                        <Typography variant="body2" color="text.secondary">
                            Erro ao carregar os dados.
                        </Typography>
                    </Box>
                )}
                {!isLoading && !isError && children}
            </Box>
        </Paper>
    );
};
